export const AuthRoleCodes = {
  Admin: 'ADMIN',
  User: 'USER',
  CustomerAirlineCompanyAdmin: 'CUSTOMER_AIRLINE_COMPANY_ADMIN',
  CustomerAirlineCompanyUser: 'CUSTOMER_AIRLINE_COMPANY_USER',
  SupplierHotelAdmin: 'SUPPLIER_HOTEL_ADMIN',
  SupplierHotelUser: 'SUPPLIER_HOTEL_USER',
  SupplierHotelHotac: 'SUPPLIER_HOTEL_HOTAC',
  SupplierTransportAdmin: 'SUPPLIER_TRANSPORT_ADMIN',
  SupplierFoodServiceAdmin: 'SUPPLIER_FOOD_SERVICE_ADMIN',
  SupplierFoodServiceUser: 'SUPPLIER_FOOD_SERVICE_USER',
  Passenger: 'PASSENGER',
  Operator: 'OPERATOR',
  ThalesOnboardApp: 'THALES_ONBOARD_APP',
  ZucchettiVerticalBooking: 'ZUCCHETTI_VERTICAL_BOOKING',
  GalaxAi: 'GALAX_AI',
} as const;

export type AuthRoleCode = (typeof AuthRoleCodes)[keyof typeof AuthRoleCodes];